import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

import withUserRole from 'decorators/withUserRole';
import { Spinner } from 'components/controls';
import { GUEST } from 'sources/constants/userRoles';

function PrivateRoute(props) {
  const { role, loginProcessing, forRole, Component, path } = props;

  if (loginProcessing) {
    return <Spinner />;
  }

  if (!role.isHasRole(forRole)) {
    return (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: props.location },
        }}
      />
    );
  }

  return <Route path={path} children={Component} />;
}

PrivateRoute.propTypes = {
  role: PropTypes.object,
  forRole: PropTypes.string,
  Component: PropTypes.func.isRequired,
  router: PropTypes.object,
  path: PropTypes.string,
};

PrivateRoute.defaultProps = {
  role: {},
  forRole: GUEST,
  router: {},
  path: '',
};

export default withUserRole(PrivateRoute);



// WEBPACK FOOTER //
// ./src/routes/PrivateRoute.jsx